
import store from '@/store';
import { defineComponent } from 'vue';
import ButtonComponent from '@/components/appComponents/Button.vue';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';
import ExternalTransactionsTable from '@/components/transactionsComponents/ExternalTransactionsTable.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';
import router from '@/router';

export default defineComponent({
    name: 'UserTransactionsListPage',
    components: {
        ButtonComponent,
        IpgTransactionSkelton,
        ExternalTransactionsTable,
        CustomPaginationComponent,
    },
    data() {
        return {
            user: '',
            activeFilterButton: 'DEFAULT',
            buttons: [
                { title: 'پیش فرض', value: 'DEFAULT' },
                { title: 'شارژ', value: 'CHARGE' },
                { title: 'انتقال', value: 'TRANSFER' },
                { title: 'درگاه', value: 'DIRECT' },
                { title: 'برداشت', value: 'WITHDRAW' },
                { title: 'صورتحساب', value: 'INVOICE' },
                { title: 'OAuth', value: 'OAUTH' },
                { title: 'محصول', value: 'PRODUCT' },
                { title: 'ووچر', value: 'VOUCHER' },
            ],
        };
    },
    computed: {
        getLoadingPanel(): boolean {
            return store.getters['panel/getLoadingPanel'];
        },
        getExternalTransactions(): unknown[] {
            return store.getters['panel/getUserTransactions'];
        },
        getGlobalPagination(): GlobalPagination {
            return store.getters['panel/getGlobalPagination'];
        },
    },
    methods: {
        back(): void {
            router.back();
            // router.push({ name: "Users" });
        },

        handelPagination() {
            const query = this.$route.query;
            store.dispatch('panel/getUserTransactionsRequest', query.user);
        },

        setFilterOfExternalTransactions(type: string): void {
            store.dispatch('panel/getExternalTransactionsRequest', type);
            this.activeFilterButton = type;
        },
    },
    mounted() {
        const query = this.$route.query;
        store.dispatch('panel/getUserTransactionsRequest', query.user);
    },
});
